import React from "react";
import CookieConsent, { Cookies } from "react-cookie-consent";
import classes from "./Cookies.module.scss";
import { useTranslation } from "react-i18next";

const CookiesBanner = () => {
  const { t } = useTranslation();
  return (
      <CookieConsent
          cookieName="site-cookie-consent"
          disableStyles
          location="bottom"
          containerClasses={classes.wrapper}
          contentClasses={classes.container}
          expires={365}
          onAccept={() => Cookies.set("site-cookie-consent", "true", { expires: 365 })}
          declineButtonId={'decline-button'}
          enableDeclineButton={true}
      >
        <div className={classes.text}>
          <p>{t("cookies.text")}</p>
        </div>

        <div className={classes.buttons}>
          <button
              className={classes.accept}
              onClick={() => {
                Cookies.set("site-cookie-consent", "true", { expires: 365 });
                const hiddenButton = document.querySelector<HTMLButtonElement>("#rcc-confirm-button");
                hiddenButton?.click();
              }}
          >
            {t("cookies.accept")}
          </button>
          <button
              className={classes.reject}
              onClick={() => {
                Cookies.set("site-cookie-consent", "false", { expires: 365 });
                const declineButton = document.querySelector<HTMLButtonElement>("#decline-button");
                declineButton?.click();
              }}
          >
            {t("cookies.reject")}
          </button>
        </div>
      </CookieConsent>
  );
};

export default CookiesBanner;
